import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Button, Row } from "react-bootstrap";
import "./CDNPage.css";
import instance, {
  apiEncryptRequest,
  currencyReturn,
  decryptData,
} from "../../Api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import AppToast from "../../AppToast";
import Loader from "../common/Loader";
import { FaX } from "react-icons/fa6";

// ── Helpers ───────────────────────────────────────────────────────────────────
const isMobileDevice = () => window.matchMedia("(max-width: 800px)").matches;
const bytesToMB = (bytes) => bytes / (1024 * 1024);

// ── Shared button style ───────────────────────────────────────────────────────
const cdnBtn = (extra = {}) => ({
  zIndex: "9",
  position: "relative",
  fontWeight: "700",
  color: "white",
  backgroundColor: "#e97730",
  outline: "4px solid #e97730",
  border: "4px solid #ffff",
  borderColor: "white",
  borderRadius: "30px",
  ...extra,
});

// ── White "pill" box for CNAME display ───────────────────────────────────────
const CnamePill = ({ children, style }) => (
  <div style={{ marginTop:"15px", display:"flex", alignItems:"center", padding:"5px", height:"50px", zIndex:"9", position:"relative", color:"white", backgroundColor:"white", outline:"3px solid #e97730", border:"3px solid #ffff", borderColor:"white", borderRadius:"30px", ...style }}>
    {children}
  </div>
);

const CnamePillText = ({ children, fontSize = "15px" }) => (
  <p style={{ color:"#555", textAlign:"center", fontSize, fontWeight:"500", paddingTop:"15px", marginLeft:"10px" }}>{children}</p>
);

const CopyIcon = ({ onClick, copied }) => (
  <div className="img-wrapper">
    <img className="hover-zoom" src="/images/copy_ic_cdn.svg" style={{ marginLeft:"5px", width:"30px", height:"30px", color:"white" }} onClick={onClick} />
    {copied && <span className="blinkStyleCdn">Copied!</span>}
  </div>
);

// ── Active CDN card — shared by mobile and web ────────────────────────────────
const CdnCard = ({ item, idx, isMobile, isParent, copiedStatus1, copiedStatus2, copiedStatus3, copiedStatus4, hoveredIndex, setHoveredIndex, onCopy, onValidateDomain, onARNvalidate, onGetCname, onUsed, onClearCache, onDisable, onRecharge }) => {
  const isHovered = hoveredIndex === idx;
  const activeBtn = {
    width: "7rem", zIndex:"9", position:"relative", marginTop:"25px", right:"-60px",
    transform:"translateY(-50%)", fontSize:"15px", fontWeight:"700", color:"white", height:"40px",
    backgroundColor: isHovered ? "#b71b1b" : "#e97730",
    outline: isHovered ? "4px solid #b71b1b" : "4px solid #e97730",
    border:"4px solid #b71b1b", borderColor:"white", borderRadius:"30px",
  };

  return (
    <div className="table-row-noti">
      <div className="bar" />
      <div className="message" style={isMobile ? { margin:"5px 0" } : undefined}>

        {/* Info rows */}
        {isMobile ? (
          <>
            <div className="desc" style={{ marginTop:"1px", maxHeight:"none", position:"relative", fontSize:"15px" }}>
              Person Name: {item.person_name}
              <button style={activeBtn}
                onClick={() => isHovered ? onDisable(item.pull_zone_id) : undefined}
                onMouseEnter={() => setHoveredIndex(idx)} onMouseLeave={() => setHoveredIndex(null)}>
                {isHovered ? "Delete" : "Active"}
              </button>
            </div>
            <div className="desc" style={{ maxHeight:"none", marginTop:"0px", fontSize:"15px" }}>Website URL : {item.website_url}</div>
            <div className="desc" style={{ maxHeight:"none", fontSize:"15px" }}>Company Name: {item.company_name}</div>
            <div className="desc" style={{ maxHeight:"none", fontSize:"15px" }}>Bandwidth: {item.datatransfer_value} TB</div>
            <div className="desc" style={{ maxHeight:"none", fontSize:"15px" }}>Contact Number: {item.contact_number}</div>
            <div className="datetime" style={{ maxHeight:"none", marginTop:"10px", fontSize:"15px" }}>Created: {item.created_at}</div>
          </>
        ) : (
          <Row>
            <div className="col-md-3" style={{ marginLeft:"10px" }}>
              <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Person Name: {item.person_name}</div>
              <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Website URL : {item.website_url}</div>
            </div>
            <div className="col-md-2">
              <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Contact Number: {item.contact_number}</div>
              <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Bandwidth: {item.datatransfer_value} TB</div>
            </div>
            <div className="col-md-6">
              <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Company Name: {item.company_name}</div>
            </div>
          </Row>
        )}

        {/* First CNAME record */}
        <div style={{ marginTop:"15px", marginLeft: isMobile ? undefined : "10px", color:"#035189", fontWeight:"500", fontSize: isMobile ? "16px" : "18px" }}>ADD CNAME Record:</div>
        <Row>
          <div className="col-md-5">
            <CnamePill style={isMobile ? undefined : { marginLeft:"15px" }}>
              <CnamePillText fontSize={isMobile ? "12px" : "15px"}>WWW</CnamePillText>
              {item.cdn_name && (
                <div>
                  <img className="hover-zoom" src="/images/copy_ic_cdn.svg"
                    style={{ marginLeft: isMobile ? "2rem" : "23rem", width:"30px", left:"80%", height:"30px", color:"white" }}
                    onClick={() => onCopy(1, "WWW", idx)} />
                  {copiedStatus1[idx] && <span className="blinkStyleCdn">Copied!</span>}
                </div>
              )}
            </CnamePill>
          </div>
          <div className="col-md-5">
            <CnamePill>
              <CnamePillText fontSize={isMobile ? "10px" : "15px"}>{item.cdn_name}</CnamePillText>
              {item.cdn_name && (
                <CopyIcon onClick={() => onCopy(2, item.cdn_name, idx)} copied={copiedStatus2[idx]} />
              )}
            </CnamePill>
          </div>
          <div className="col-md-1">
            {item.domain_validate !== 1 ? (
              <button style={cdnBtn({ width:"11rem", marginTop: isMobile?"20px":"15px", fontSize:"15px", height: isMobile?"40px":"50px" })}
                onClick={() => onValidateDomain(item.pull_zone_id, item.website_url, item.arn)}>Domain Validate</button>
            ) : (
              <div>
                <img src="/images/verified_success.png" style={{ height:"34px", width:"34px", zIndex:"9", position:"relative", marginTop: isMobile?"-70px":"15px" }} />
                <button style={cdnBtn({ width:"6rem", zIndex:"9", position:"relative", left: isMobile?"2%":"45%", bottom:"35px", fontWeight:"700", height:"40px" })}
                  onClick={() => onValidateDomain(item.pull_zone_id, item.website_url, item.arn)}>Check</button>
              </div>
            )}
          </div>
        </Row>

        {/* Second CNAME record */}
        {item.cname_name && item.cname_value && (
          <>
            <div style={{ marginTop:"15px", marginLeft: isMobile ? undefined : "10px", color:"#035189", fontWeight:"500", fontSize: isMobile ? "16px" : "18px" }}>ADD CNAME Record:</div>
            <Row>
              <div className="col-md-5">
                <CnamePill style={isMobile ? undefined : { marginLeft:"15px" }}>
                  <CnamePillText fontSize={isMobile ? "9px" : "15px"}>{item.cname_name}</CnamePillText>
                  <CopyIcon onClick={() => { navigator.clipboard.writeText(item.cname_name); onCopy(3, item.cname_name, idx); }} copied={copiedStatus3[idx]} />
                </CnamePill>
              </div>
              <div className="col-md-5">
                <CnamePill>
                  <CnamePillText fontSize={isMobile ? "8px" : "14px"}>{item.cname_value}</CnamePillText>
                  <CopyIcon onClick={() => onCopy(4, item.cname_value, idx)} copied={copiedStatus4[idx]} />
                </CnamePill>
              </div>
              <div className="col-md-1">
                <button style={cdnBtn({ width:"11rem", marginTop: isMobile?"20px":"15px", fontSize:"15px", height: isMobile?"40px":"50px" })}
                  onClick={() => onARNvalidate(item.pull_zone_id, item.website_url)}>Certificate Validate</button>
              </div>
            </Row>
          </>
        )}

        {/* Action buttons */}
        <div>
          <button style={cdnBtn({ width: isMobile?"6rem":"10rem", marginLeft: isMobile?undefined:"15px", marginTop: isMobile?"15px":"30px", marginBottom:"10px", fontSize:"15px", height: isMobile?"40px":"50px" })}
            onClick={() => onUsed(item.pull_zone_id, item.website_url, item.id)}>CDN Used</button>
          <button style={cdnBtn({ width: isMobile?"7rem":"10rem", marginLeft:"15px", marginTop: isMobile?"20px":"20px", fontSize:"15px", height: isMobile?"40px":"50px" })}
            onClick={() => onClearCache(item.pull_zone_id)}>Clear Cache</button>
          {!item.cname_name && !item.cname_value && item.domain_validate === 1 && (
            <button className="loader" style={cdnBtn({ width: isMobile?"10rem":"11rem", marginLeft: isMobile?"0px":"20px", marginTop: isMobile?"15px":"20px", fontSize:"15px", height: isMobile?"40px":"50px" })}
              onClick={() => onGetCname(item.pull_zone_id, item.arn)}>Generate CName</button>
          )}
          {/* Recharge: always on mobile; gated by isLoginByParentUser on web (handled by caller via onRecharge being defined or not) */}
          {isMobile ? (
            <button style={cdnBtn({ width:"6rem", marginLeft:"15px", marginTop:"20px", fontSize:"15px", height:"40px" })}
              onClick={onRecharge}>Recharge</button>
          ) : (
            isParent && (
              <button style={cdnBtn({ width:"10rem", marginLeft:"20px", marginTop:"20px", fontSize:"15px", height:"50px" })}
                onClick={onRecharge}>Recharge</button>
            )
          )}
        </div>
      </div>

      {/* Web-only: Active/Delete button + created date */}
      {!isMobile && (
        <div className="">
          {isParent && (
            <button style={{ width:"10rem", zIndex:"9", position:"relative", marginTop:"15px", fontWeight:"700", color:"white", height:"50px",
              backgroundColor: isHovered?"#b71b1b":"#e97730", outline: isHovered?"4px solid #b71b1b":"4px solid #e97730",
              border:"4px solid #b71b1b", borderColor:"white", borderRadius:"30px" }}
              onClick={() => isHovered ? onDisable(item.pull_zone_id) : undefined}
              onMouseEnter={() => setHoveredIndex(idx)} onMouseLeave={() => setHoveredIndex(null)}>
              {isHovered ? "Delete" : "Active"}
            </button>
          )}
          <p style={{ fontWeight:"600", marginTop:"100px" }}>Created</p><br />
          <p style={{ position:"relative", marginTop:"-40px" }}>{item.created_at}</p>
        </div>
      )}
    </div>
  );
};

// ── Disabled CDN row ──────────────────────────────────────────────────────────
const DisabledCdnCard = ({ item, isMobile }) => (
  <div className="table-row-noti">
    <div className="bar" />
    <div className="message">
      {isMobile ? (
        <Row>
          <div className="col-md-3">
            <div className="desc" style={{ fontWeight:"500", fontSize:"15px" }}>Person Name: {item.person_name}</div>
            <div className="desc" style={{ fontWeight:"500", fontSize:"15px" }}>Website URL : {item.website_url}</div>
          </div>
          <div className="col-md-2">
            <div className="desc" style={{ fontWeight:"500", fontSize:"15px" }}>Contact Number: {item.contact_number}</div>
            <div className="desc" style={{ fontWeight:"500", fontSize:"15px" }}>Bandwidth: {item.datatransfer_value} TB</div>
          </div>
          <div className="col-md-6">
            <div className="desc" style={{ fontWeight:"500", fontSize:"15px" }}>Company Name: {item.company_name}</div>
          </div>
          <div className="datetime" style={{ maxHeight:"none", marginTop:"10px", fontSize:"15px" }}>Created: {item.created_at}</div>
        </Row>
      ) : (
        <Row>
          <div className="col-md-3" style={{ marginLeft:"10px" }}>
            <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Person Name: {item.person_name}</div>
            <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Website URL : {item.website_url}</div>
          </div>
          <div className="col-md-2">
            <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Contact Number: {item.contact_number}</div>
            <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Bandwidth: {item.datatransfer_value} TB</div>
          </div>
          <div className="col-md-6">
            <div className="desc" style={{ fontWeight:"500", fontSize:"20px" }}>Company Name: {item.company_name}</div>
          </div>
        </Row>
      )}

      {/* First CNAME — read-only */}
      <div style={{ marginTop:"15px", marginLeft: isMobile?undefined:"10px", color:"#035189", fontWeight:"500", fontSize: isMobile?"16px":"18px" }}>ADD CNAME Record:</div>
      <Row>
        <div className="col-md-5">
          <CnamePill style={isMobile ? undefined : { marginLeft:"15px" }}>
            <CnamePillText fontSize={isMobile?"12px":"18px"}>WWW</CnamePillText>
          </CnamePill>
        </div>
        <div className={isMobile ? "col-md-5" : "col-md-6"}>
          <CnamePill>
            <CnamePillText fontSize={isMobile?"10px":"18px"}>{item.cdn_name}</CnamePillText>
          </CnamePill>
        </div>
      </Row>

      {/* Second CNAME — read-only */}
      {item.cname_name && item.cname_value && (
        <>
          <div style={{ marginTop:"15px", marginLeft: isMobile?undefined:"10px", color:"#035189", fontWeight:"500", fontSize: isMobile?"16px":"18px" }}>ADD CNAME Record:</div>
          <Row>
            <div className="col-md-5">
              <CnamePill style={isMobile ? undefined : { marginLeft:"15px" }}>
                <CnamePillText fontSize={isMobile?"10px":"18px"}>{item.cname_name}</CnamePillText>
              </CnamePill>
            </div>
            <div className={isMobile ? "col-md-5" : "col-md-6"}>
              <CnamePill>
                <CnamePillText fontSize={isMobile?"10px":"18px"}>{item.cname_value}</CnamePillText>
              </CnamePill>
            </div>
          </Row>
        </>
      )}
      <div></div>
    </div>

    {/* Web-only: created date after .message */}
    {!isMobile && (
      <div className="datetime">
        <p style={{ fontWeight:"600" }}>Created</p><br />
        <p style={{ position:"relative", marginTop:"-40px" }}>{item.created_at}</p>
      </div>
    )}
  </div>
);

// ── Main component ────────────────────────────────────────────────────────────
const CDNPage = () => {
  const navigate = useNavigate();
  const { smuser, appCurrency, isLoginByParentUser } = useAuth();

  const [loading, setLoading]         = useState(false);
  const [isMobile, setIsMobile]       = useState(isMobileDevice);
  const [activeButton, setActiveButton] = useState("");

  // CDN info / used — UI is commented out but state + handlers preserved
  const [whatIsCDN, setWhatIsCDN]     = useState("");
  const [usedCDN, setUsedCDN]         = useState("");
  const [cdnInfo, setCdnInfo]         = useState("");
  const [cdnUsed, setCdnUsed]         = useState("");

  const handleOptionWhatIsCDN = (e) => { setWhatIsCDN(e.target.value); setCdnInfo(e.target.value); };
  const handleOptionUsedCDN   = (e) => { setUsedCDN(e.target.value); setCdnUsed(e.target.value); };

  // Form state
  const [companyName, setCompanyName]     = useState("");
  const [websiteOrigin, setWebsiteOrigin] = useState("");
  const [websiteUrl, setWebsiteUrl]       = useState("");
  const [personName, setPersonName]       = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [dataTransferValue, setDataTransferValue] = useState("");
  const [value, setValue]                 = useState(0);
  const [showCdnForm, setShowCdnForm]     = useState(false);
  const [cdnList, setCdnList]             = useState(null);
  const [cdnGBPrice, setGBPrice]          = useState("");
  const [cdnTBPrice, setTBPrice]          = useState("");

  // CDN Used popup
  const [isCDNUsedView, setIsCDNUsedView]               = useState(false);
  const [totalBytesDownloaded, setTotalBytesDownloaded] = useState("");
  const [totalRequests, setTotalRequests]               = useState("");
  const [totalBytesUploaded, setTotalBytesUploaded]     = useState("");
  const [websiteURL, setWebsiteURL]                     = useState("");

  const [searchText, setSearchText]             = useState("");
  const [activeStatusButton, setActiveStatusButton] = useState("Active");
  const [hoveredIndex, setHoveredIndex]         = useState(null);

  // Cache/transfer selectors
  const selectedCacheTypes = ["js","images","css","gif","webp","jpg","png"];
  const dataTransfers      = ["GB","TB"];
  const [selectedOptions, setSelectedOptions]     = useState(selectedCacheTypes);
  const [selectedTransfers, setSelectedTransfers] = useState("GB");

  // Copy state — 4 slots
  const [copiedStatus1, setCopiedStatus1] = useState([]);
  const [copiedStatus2, setCopiedStatus2] = useState([]);
  const [copiedStatus3, setCopiedStatus3] = useState([]);
  const [copiedStatus4, setCopiedStatus4] = useState([]);

  // Carousel index (unused but preserved)
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => setIndex(selectedIndex);

  // Fix: original had [isMobile] in deps — ListCDN() + CdnPrice() re-fired on
  // every resize. Resize is now handled by its own listener only.
  useEffect(() => {
    window.scrollTo(0, 0);
    ListCDN();
    CdnPrice();
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Unified copy handler — replaces 4 identical handleCopy1-4 functions ───
  const handleCopy = (slot, text, idx) => {
    const sets = [null, setCopiedStatus1, setCopiedStatus2, setCopiedStatus3, setCopiedStatus4];
    const gets = [null, copiedStatus1,    copiedStatus2,    copiedStatus3,    copiedStatus4   ];
    const next = [...(gets[slot] || [])];
    next[idx] = true;
    sets[slot](next);
    navigator.clipboard.writeText(text).then(() => {
      setTimeout(() => { next[idx] = false; sets[slot]([...next]); }, 2000);
    });
  };

  // ── API helper ────────────────────────────────────────────────────────────
  const apiPost = async (url, payload) => {
    const enc = await apiEncryptRequest(payload);
    const res = await instance.post(url, enc);
    return decryptData(res.data);
  };

  // ── API calls ──────────────────────────────────────────────────────────────
  const ListCDN = async () => {
    setLoading(true);
    try {
      const data = await apiPost("/cdnlist", { user_id: smuser.id });
      const all = Object.values(data.cdn_list);
      const active = all.filter((i) => i.status === 1).reverse();
      setCdnList(active);
      const len = all.length;
      setCopiedStatus1(Array(len).fill(false));
      setCopiedStatus2(Array(len).fill(false));
      setCopiedStatus3(Array(len).fill(false));
      setCopiedStatus4(Array(len).fill(false));
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const CdnPrice = async () => {
    setLoading(true);
    try {
      const data = await apiPost("/cdn_price", { user_id: smuser.id });
      if (data.status) { setGBPrice(data.cdn_price.gb_price); setTBPrice(data.cdn_price.price); }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const UpdateCDN = async () => {
    setLoading(true);
    const amount = selectedTransfers === "GB" ? value * cdnGBPrice * 1024 : value * cdnTBPrice * 1024;
    if (value !== 0 && smuser.total_credit > amount && companyName !== "" && websiteOrigin !== "" && websiteUrl !== "" && dataTransferValue !== "" && personName !== "" && contactNumber !== "") {
      try {
        const data = await apiPost("/createDistribution", {
          user_id: smuser.id,
          company_name: companyName,
          website_origin: `WWW.${websiteOrigin}`,
          website_url: `WWW.${websiteUrl}`,
          datatransfer_value: selectedTransfers === "GB" ? dataTransferValue : dataTransferValue * 1024,
          person_name: personName,
          contact_number: contactNumber,
          amount,
          cache_items: selectedOptions,
        });
        if (data.status) {
          toast((t) => <AppToast id={t.id} message="CDN Info is updated!" />);
          setShowCdnForm(false);
          ListCDN();
        }
      } catch (e) { console.error(e); }
    }
    if (smuser.total_credit < amount) toast((t) => <AppToast id={t.id} message="Not enough balance! Add money to wallet" />);
    else if (companyName === "") toast((t) => <AppToast id={t.id} message="CDN name can not be empty!" />);
    else if (websiteUrl === "") toast((t) => <AppToast id={t.id} message="CDN Website url can not be empty!" />);
    else if (personName === "") toast((t) => <AppToast id={t.id} message="Person Name can not be empty!" />);
    else if (contactNumber === "") toast((t) => <AppToast id={t.id} message="Contact Number can not be empty!" />);
    else if (value === 0) toast((t) => <AppToast id={t.id} message="Bandwidth can not be 0!" />);
    setLoading(false);
  };

  const UsedCDN = async (pull_zone_id, websiteUrl, Id) => {
    setLoading(true);
    try {
      const data = await apiPost("/usedcdn", { user_id:smuser.id, distribution_id:pull_zone_id, id:Id });
      if (data.status) {
        setIsCDNUsedView(true);
        setTotalBytesDownloaded(bytesToMB(data.totalBytesDownloaded));
        setTotalRequests(data.totalRequests);
        setTotalBytesUploaded(bytesToMB(data.totalBytesUploaded));
        setWebsiteURL(websiteUrl);
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const createInvalidation = async (pull_zone_id) => {
    setLoading(true);
    try { await apiPost("/createInvalidation", { user_id:smuser.id, distribution_id:pull_zone_id }); } catch (e) { console.error(e); }
    setLoading(false);
  };

  const CDNgetcertificate = async (pull_zone_id, website_url) => {
    setLoading(true);
    try { await apiPost("/getcertificate", { user_id:smuser.id, distribution_id:pull_zone_id, domain_name:website_url }); ListCDN(); } catch (e) { console.error(e); }
    setLoading(false);
  };

  const getCname = async (pull_zone_id, arnVal) => {
    setLoading(true);
    try { await apiPost("/getcname", { user_id:smuser.id, distribution_id:pull_zone_id, arn:arnVal }); ListCDN(); } catch (e) { console.error(e); }
    setLoading(false);
  };

  const ARNvalidate = async (pull_zone_id, domain_name) => {
    setLoading(true);
    try {
      const data = await apiPost("/arnvalidate", { user_id:smuser.id, distribution_id:pull_zone_id, domain_name });
      ListCDN();
      if (data.message) toast((t) => <AppToast id={t.id} message={`${data.DomainName}\n ip: ${data.message}`} isMobile={isMobile} />);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const validateDomain = async (pull_zone_id, domain_name, arnVal) => {
    setLoading(true);
    try {
      const data = await apiPost("/validate_domain", { user_id:smuser.id, distribution_id:pull_zone_id, domain_name, arn:arnVal });
      ListCDN();
      if (data.message) toast((t) => <AppToast id={t.id} message={data.message} />);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const disableCDN = async (pull_zone_id) => {
    setLoading(true);
    try {
      const data = await apiPost("/disable", { user_id:smuser.id, distribution_id:pull_zone_id });
      if (data.message) toast((t) => <AppToast id={t.id} message={data.message} />);
      ListCDN();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  // showCdnUsed — preserved (posts to /cdnmonitor, no state side-effects)
  const showCdnUsed = async (data) => {
    try {
      const enc = await apiEncryptRequest({ id:data.id, pull_id:data.pull_zone_id, user_id:smuser.id });
      const res = await instance.post("/cdnmonitor", enc);
      await decryptData(res.data);
    } catch (e) { console.error(e); }
  };

  const handleRedirect  = () => navigate("/wallet", { state:{ isServerOrCDN:"CDN" } });
  const handleChange    = (e) => { setValue(e.target.value); setDataTransferValue(e.target.value); };
  const handleSelection = (opt) => setSelectedOptions((prev) => prev.includes(opt) ? prev.filter((i) => i !== opt) : [...prev, opt]);
  const handleSelectionChange = (opt) => { if (selectedTransfers !== opt) setSelectedTransfers(opt); };

  // Shared card props
  const cardProps = {
    copiedStatus1, copiedStatus2, copiedStatus3, copiedStatus4,
    hoveredIndex, setHoveredIndex,
    onCopy: handleCopy,
    onValidateDomain: validateDomain,
    onARNvalidate: ARNvalidate,
    onGetCname: getCname,
    onUsed: UsedCDN,
    onClearCache: createInvalidation,
    onDisable: disableCDN,
    onRecharge: handleRedirect,
  };

  // Filtered lists (search applied; status filter already in setCdnList for active)
  const activeCDNs   = (cdnList || []).filter((i) => i.website_url.toLowerCase().includes(searchText.toLowerCase()));
  const disabledCDNs = (cdnList || []).filter((i) => i.status === 0 && i.website_url.toLowerCase().includes(searchText.toLowerCase()));

  // Search bar — reused on both mobile and web
  const SearchBar = ({ style }) =>
    cdnList?.filter((i) => i.status === 1).length > 0 ? (
      <div className="input-container" style={{ position:"relative", border:"2px solid #035189", ...style }}>
        <input type="text" name="search" className="input-signup input-tickets" placeholder="Search Website" value={searchText}
          style={{ fontSize:"24px", color:"black", textAlign:"center", width:"10px" }}
          onChange={(e) => setSearchText(e.target.value)} />
        {searchText && (
          <button style={{ backgroundColor:"transparent", border:"none" }} onClick={() => setSearchText("")}>
            <FaX style={{ color:"#154e7a", display:"inline-block", fontSize:"19px" }} />
          </button>
        )}
      </div>
    ) : null;

  // Create CDN form — web variant has extra fields (websiteOrigin, cache types, GB/TB selector)
  const CdnForm = ({ web }) => (
    <div className={web ? undefined : "features-section-solution"} style={web ? undefined : { marginTop:"0px", marginLeft:"5%", width:"90%" }}>
      <div className="register-main see-full" style={{ marginTop:"2rem" }}>
        <div className="bg-img">
          <img src="/images/blue-box-bg.svg" alt="" style={web ? undefined : { width:"100%" }} />
        </div>
        <form className="see-full">
          <div className="form-top">
            <div style={{ display:"flex" }}>
              <h4 className="text-white">Create CDN</h4>
              {web ? (
                <h4 className="text-white" style={{ position:"absolute", right:"1px" }}>
                  Price: {currencyReturn({ price: selectedTransfers==="GB" ? value*cdnGBPrice*1024 : value*cdnTBPrice*1024, symbol:smuser.prefer_currency, rates:appCurrency })}
                </h4>
              ) : (
                <h6 className="text-white" style={{ position:"absolute", right:"1px" }}>
                  Price: {currencyReturn({ price: selectedTransfers==="GB" ? value*cdnGBPrice : value*cdnTBPrice, symbol:smuser.prefer_currency, rates:appCurrency })}
                </h6>
              )}
            </div>

            {web && (
              <div style={{ display:"flex", alignItems:"center", gap:"20px", flexWrap:"wrap", marginLeft:"5px" }}>
                <button style={cdnBtn({ width:"9rem", height:"40px", marginTop:"5px", fontSize:"15px" })}
                  onClick={(e) => { e.preventDefault(); selectedOptions.length===selectedCacheTypes.length ? setSelectedOptions([]) : setSelectedOptions(selectedCacheTypes); }}
                  onMouseOver={(e) => (e.target.style.fontSize="17px")} onMouseOut={(e) => (e.target.style.fontSize="16px")}>
                  {selectedOptions.length===selectedCacheTypes.length ? "Unselect All" : "Select All"}
                </button>
                <div className="multi-select-container">
                  {selectedCacheTypes.map((opt) => (
                    <div key={opt} className="custom-radio">
                      <input type="checkbox" id={opt} name={opt} checked={selectedOptions.includes(opt)} onChange={() => handleSelection(opt)} />
                      <label htmlFor={opt} className="radio-label">{opt}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="input-container">
              <input type="text" name="CompanyName" className="input-signup" placeholder="Your Company Name" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
            </div>
            {web && (
              <div className="input-container">
                <span style={{ padding:"0 5px", fontSize:"30px", marginTop:"-5px" }}>www.</span>
                <input type="text" name="CompanyName" className="input-signup" placeholder="Website Origin" value={websiteOrigin} onChange={(e) => setWebsiteOrigin(e.target.value)} />
              </div>
            )}
            <div className="input-container">
              {web && <span style={{ padding:"0 5px", fontSize:"30px", marginTop:"-5px" }}>www.</span>}
              <input type="text" name="CompanyName" className="input-signup" placeholder="Enter Your Website / APP URL Where you Want" value={websiteUrl} onChange={(e) => setWebsiteUrl(e.target.value)} />
            </div>

            {web && (
              <div className="multi-select-container">
                {dataTransfers.map((opt) => (
                  <div key={opt} className="custom-radio">
                    <input type="checkbox" id={opt} name={opt} checked={selectedTransfers===opt} onChange={() => handleSelectionChange(opt)} />
                    <label htmlFor={opt} className="radio-label">{opt}</label>
                  </div>
                ))}
              </div>
            )}

            <p style={{ fontSize:"14px", fontWeight:"600", color:"white", marginTop: web?"5px":undefined, marginRight:"10px" }}>
              How Much Bandwidth You Have Right Now Monthly?
            </p>
            <div style={{ marginLeft:"-15px", marginRight:"-10px", marginTop: web?"-25px":"-23px", marginBottom:"-10px" }}>
              <div className="range-slider">
                <div className="tooltip-horz" style={{ left:`${value}%` }}>
                  {value} {web ? (selectedTransfers==="GB" ? "GB" : "TB") : "TB"}
                </div>
                <input type="range" min="0" max="100" value={value} onChange={handleChange} className="custom-rangeInput"
                  style={{ background:`linear-gradient(to right, #e97730 ${value}%, #ddd ${value}%)` }} />
              </div>
            </div>

            <div className="input-container">
              <input type="text" name="CompanyName" className="input-signup" placeholder="Name of the Contact Person" value={personName} onChange={(e) => setPersonName(e.target.value)} />
            </div>
            <div className="input-container">
              <input type={web?"number":"text"} name="CompanyName" className="input-signup" placeholder="Contact Number" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
            </div>
          </div>

          <div style={{ display:"flex", marginTop:"15px", marginLeft: web?undefined:"-5px" }}>
            <div className="log-in" onClick={() => UpdateCDN()}>
              <a className="media-link">
                <div className="media-banner" style={{ width:"auto", height:"50px", marginTop:"10px", marginLeft:"1.8rem" }}>
                  <img className="normal-banner" src="/images/more-info-btn-bg.svg" alt="" />
                  <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="/images/search-btn-hover.png" />
                  <span className="login-text" style={{ fontSize:"20px", color: web?"white":"#07528B", marginTop:"0px", fontWeight:"600" }}
                    onMouseOver={web?(e)=>(e.target.style.color="#07528B"):undefined}
                    onMouseOut={web?(e)=>(e.target.style.color="white"):undefined}>Submit</span>
                </div>
              </a>
            </div>
            <div className="log-in" onClick={() => setShowCdnForm(false)}>
              <a className="media-link">
                <div className="media-banner" style={{ width:"auto", height:"50px", marginTop:"10px", marginLeft:"0.5rem" }}>
                  <img className="normal-banner" src="/images/signup-btn-bg.png" alt="" />
                  <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="/images/search-btn-hover.png" />
                  <span className="login-text" style={{ fontSize:"20px", color:"#07528B", marginTop:"0px", fontWeight:"600" }}>Cancel</span>
                </div>
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );

  // ── RENDER ─────────────────────────────────────────────────────────────────
  return (
    <div style={{ width:"100%", minHeight:"65rem", position:"relative", backgroundImage:"url(/main-bg.jpg)", backgroundSize:"cover", backgroundRepeat:"round", backgroundBlendMode:"overlay" }}>
      {loading && (
        <div className="loading-overlay" style={{ zIndex:"999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}

      {/* CDN Used popup */}
      {isCDNUsedView && (
        <div style={{ display:"grid", justifyItems:"center" }}>
          <div style={{ backgroundColor:"#035189", boxShadow:"0px 0px 10px rgba(0,0,0,0.1)", borderRadius:"12px", border:"2px solid #e97730", top:"30%", position:"absolute", zIndex:"999999", width: isMobile?"100%":"20%", height: isMobile?"25%":"15rem" }}>
            <div style={{ display:"grid", justifyItems:"center" }}>
              <button style={{ zIndex:"9", position:"absolute", backgroundColor:"transparent", border:"none", right:"0" }} onClick={() => setIsCDNUsedView(false)}>
                <FaX style={{ marginTop:"5px", color:"#e97730", display:"inline-block", fontSize:"19px" }} />
              </button>
              <h1 style={{ color:"white", width:"25rem", height:"100px", fontSize:"22px", fontWeight:"bold", marginTop:"4rem", textAlign:"center" }}>
                Website URL : {websiteURL}<br /><br />
                Total CDN Used : {totalBytesDownloaded} MB
              </h1>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        /* ── MOBILE ── */
        <div className="" style={{ height:"50rem" }}>
          <div className="heading-dotted-cdn">CDN <span /></div>

          {!showCdnForm && (
            <div style={{ position:"absolute", marginLeft:"5px", marginTop:"0rem" }}>
              <Button style={{ background:"#035189", border:"none", fontSize:"20px", padding:"5px 15px", color:"#fff", fontWeight:"600", marginBottom:"10px" }}
                onClick={() => setShowCdnForm(true)}>New CDN</Button>
            </div>
          )}

          {showCdnForm && <CdnForm />}

          <div className="heading-dotted-support" style={{ position:"absolute", marginLeft: showCdnForm?"":" -50px", marginTop: showCdnForm?"45rem":"8rem" }}>CDNs </div>

          <SearchBar style={{ marginLeft:"52%", width:"12rem", marginTop: showCdnForm?"0px":"70px", height:"40px" }} />

          <div style={{ marginTop:"6rem", marginLeft:"10px", width:"95%", maxHeight:"50rem", overflowY:"auto" }}>
            {cdnList &&
              cdnList.reverse().filter((i) => i.status===1 && i.website_url.toLowerCase().includes(searchText.toLowerCase()))
                .map((item, idx) => (
                  <CdnCard key={item.id || idx} item={item} idx={idx} isMobile isParent {...cardProps} />
                ))}
            {cdnList && cdnList.length===0
              ? <div style={{ textAlign:"center", marginTop:"2rem", fontSize:"24px", fontWeight:"400" }}>No Records</div>
              : <div />}
          </div>

          {activeStatusButton==="Disabled" && (
            <div style={{ marginTop:"5rem", marginLeft:"10px", width:"95%", maxHeight:"50rem", overflowY:"auto" }}>
              {cdnList &&
                cdnList.reverse().filter((i) => i.status===0 && i.website_url.toLowerCase().includes(searchText.toLowerCase()))
                  .map((item, idx) => <DisabledCdnCard key={item.id || idx} item={item} isMobile />)}
              <div style={{ textAlign:"center", fontSize:"25px", marginTop:"20px" }}>
                {cdnList && cdnList.filter((i) => i.status===0).length===0 ? <div>No Records</div> : <div />}
              </div>
            </div>
          )}
        </div>
      ) : (
        /* ── WEB ── */
        <div className="features-page-solution" style={{ padding:"5rem" }}>
          {isLoginByParentUser==1 && <div className="heading-dotted-cdn">CDN <span /></div>}

          {isLoginByParentUser==1 && !showCdnForm && (
            <div style={{ position:"absolute", marginLeft:"8rem", marginTop:"1rem" }}>
              <Button style={{ background:"#035189", border:"none", fontSize:"20px", padding:"5px 15px", color:"#fff", fontWeight:"600", marginBottom:"10px" }}
                onClick={() => setShowCdnForm(true)}>New CDN</Button>
            </div>
          )}

          {isLoginByParentUser==1 && showCdnForm && (
            <Row>
              <div className="col-md-2" />
              <div className="col-md-9">
                <div className="features-section-solution" style={{ marginTop:"20px" }}>
                  <CdnForm web />
                </div>
              </div>
              <div className="col-md-2" />
            </Row>
          )}

          <div className="heading-dotted-support" style={{ position:"absolute", marginLeft: showCdnForm?"":(isLoginByParentUser==1?"-75px":""), marginTop: showCdnForm?"":(isLoginByParentUser==1?"8rem":"1rem") }} />

          <SearchBar style={{ marginLeft:"82%", width:"18rem", marginTop:"60px", height:"55px" }} />

          <div style={{ marginTop:"2rem", marginLeft:"8rem" }}>
            {cdnList &&
              cdnList.filter((i) => i.status===1 && i.website_url.toLowerCase().includes(searchText.toLowerCase()))
                .map((item, idx) => (
                  <CdnCard key={item.id || idx} item={item} idx={idx} isMobile={false} isParent={isLoginByParentUser==1} {...cardProps} />
                ))}
            {cdnList && cdnList.length===0
              ? <div style={{ position:"relative", left:"45%", marginTop:"12rem", fontSize:"24px", fontWeight:"400" }}>No Records</div>
              : <div />}
          </div>

          {activeStatusButton==="Disabled" && (
            <div style={{ marginTop:"2rem", marginLeft:"8rem" }}>
              {cdnList &&
                cdnList.filter((i) => i.status===0 && i.website_url.toLowerCase().includes(searchText.toLowerCase()))
                  .map((item, idx) => <DisabledCdnCard key={item.id || idx} item={item} isMobile={false} />)}
              <div style={{ textAlign:"center", fontSize:"25px", marginTop:"20px" }}>
                {cdnList && cdnList.filter((i) => i.status===0).length===0 ? <div>No Records</div> : <div />}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="apptoast-align">
        <Toaster position={isMobile?"top-center":"bottom-right"} reverseOrder={false} />
      </div>
    </div>
  );
};

export default CDNPage;